import { Microphone } from '@myinterview/component-library';
import { useActor } from '@xstate/react';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { ActorRef, DoneInvokeEvent } from 'xstate';

interface IProps {
  microphoneRef: ActorRef<DoneInvokeEvent<any>, any>
}

export const MicrophoneIndicator:React.FC<IProps> = ({ microphoneRef }) => {
  const [mic] = useActor(microphoneRef);
  const micRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const level = Math.max(1, Math.min(1 + mic.context.micData / 25, 1.6)).toString();
    micRef.current?.style.setProperty('--myinterview-widget-voice-level', level);
  }, [mic.context.micData]);

  const microphoneClassNames = classNames({
    'myinterview-widget__microphone-indicator': true,
    'myinterview-widget__microphone-indicator--hidden': !mic.context.mediaStream,
  });

  return (
    <div ref={micRef} className={microphoneClassNames} title="Volume of the microphone">
      <Microphone />
    </div>
  );
};
